// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Adatmenet",
        "pull_refresh": "Húzza le a frissítést",
        "release_refresh": "Engedje el a frissítést",
        "refresh_loading": "Terhelés…",
        "footer_text": "Szolgáltatások szolgáltatója: Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Keresési ország/régió",
        "my_flow": "Adataim",
        "charge_code": "Utalványkód",
        "coupons": "Kuponok",
        "local_package": "Helyi adatok",
        "more": "Több",
        "popular_destination": "Ország/régió",
        "buy_now": "Vásároljon most",
        "package_useing": "Aktív",
        "unused": "Inaktív",
        "download_app": "Töltse le az alkalmazást",
        "enter_the_mall_list": "Lépjen a bevásárlóközpontba",
        "no_data": "Nincs adat",
        "no_data_available": "Nincsenek elérhető adatok",
        "copy_success": "Sikeresen másolva",
        "copy_fail": "A másolás sikertelen",
        "meritsTitle": "Milyen előnyei vannak?",
        "merits1": "Nincs SIM szükséges & Nincs havi díj",
        "merits2": "Integrált a top 2-3 operátorral az automatikus hálózatváltáshoz",
        "go_buy": "Vásároljon most",
        "instant_savings": "Megtakarítás",
        "expires_in": "Lejár",
        "download_app_tips": "Töltse le az appot több ajánlat és élményért"
    },
    "packages": {
        "sub_title": {
            "us": "Kivéve Guam, Saipan",
            "it": "Beleértve a Vatikán City -t, San Marino -t",
            "va": "Beleértve Olaszországot, San Marinót",
            "sm": "Beleértve Olaszországot, a Vatikán City -t",
            "ma": "Beleértve Nyugat -Szaharát",
            "eh": "Beleértve Marokkóot",
            "ch": "Beleértve a liechtensteint is",
            "li": "Beleértve Svájcot",
            "fr": "Beleértve Monacót is",
            "mc": "Beleértve Franciaországot",
            "fi": "Beleértve az Aland -szigeteket",
            "ax": "Beleértve Finnországot",
            "gu": "Beleértve az északi mariana -szigeteket",
            "mp": "Beleértve Guamot"
        },
        "unlimited_packages": "Korlátlan adatcsomag",
        "normal_packages": "Normál adatcsomag",
        "multi_region_packages": "Többregion",
        "regional_data": "Regionális adatok",
        "high_speed_text": "nagy sebességű adatok",
        "infiniteFlow": "Korlátlan adatok",
        "unLimitData": "Határozatlan",
        "high_speed_text_year": "Nagy sebességű/MP",
        "package_list": "Csomaglista",
        "special_offer": "Akciók",
        "first_month": "1. Hónap",
        "periodUnit": {
            "day": "nap (ek)",
            "month": "hónap",
            "hour": "óra (ek)",
            "year": "év"
        },
        "periodUnits": {
            "day": "nap (ek)",
            "month": "hónap",
            "hour": "óra (ek)",
            "year": "évek"
        },
        "periodUnitSimp": {
            "day": "D",
            "month": "-ra",
            "hour": "H",
            "year": "a"
        },
        "periodUnitMonthly":"Hónapos",
        "periodUnitsSimp": {
            "day": "D",
            "month": "-ra",
            "hour": "H",
            "year": "a"
        },
        "unlimited_good_name": {
            "day": "Napsugárzás",
            "month": "Havi bérlet",
            "year": "Évente átadás"
        },
        "continuousMonth": "Folyamatos hónapok",
        "continuousDay": "Folyamatos napok",
        "continuousYear": "Folyamatos évek",
        "day_invalid": "Lejár az aktuális napon",
        "month_invalid": "Lejár a folyó hónapban",
        "immediate_valid": "Azonnal hatásos",
        "tomorrow_day_valid": "Hatékony a következő naptól",
        "tomorrow_month_valid": "Hatályba lép a következő hónaptól",
        "detail": {
            "cell_flow": "Adat",
            "cell_period": "Érvényesség",
            "buy_quantity": "Összeg",
            "use_area": "Lefedettség",
            "use_intro": "Feltételek",
            "buy_btn": "Rendelés",
            "pay": "Fizetés",
            "buy_tips": "A %@packageName csomagot használod. Szereted megvásárolni ezt a csomagot?",
            "haveOrderTips": "Fizetésre váró rendelés létrehozva. Kattintson megerősítésre a adatsayfamra！"
        },
        "confirm": {
            "title": "Megrendelés megerősítése",
            "real_pay_amount": "Fizetett összeg",
            "online_payment": "Online fizetés",
            "create_order_error": "A beállítás sikertelen"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Megrendelési állapot megszerzése...",
            "buy_success": "Rendeljen teljes",
            "buy_pending": "Függőben lévő megerősítés",
            "buy_pending_tip": "Fizetés a folyamatban… Ha a fizetés nem került átadásra 10 percen belül, kérjük, vegye fel velünk a kapcsolatot a támogatásért.",
            "get_payment_info_fail": "Fizetési információk beszerzése sikertelen",
            "cell_package": "Csomag",
            "cell_buy_amount": "Altotikus",
            "cell_real_amount": "Fizetett összeg",
            "go_to_order_btn": "Menj a csomagomhoz",
            "back_home": "Vissza otthon",
            "back_mall": "Vissza a bevásárlóközpontba",
            "ordersn_empty": "Az SN megrendelés nem lehet üres",
            "order_search_error": "Váratlan hiba",
            "goodsName": 'Terméknév'
        },
        "fail": {
            "payment_fail": "A fizetés sikertelen",
            "back_home": "Vissza otthon"
        }
    },
    "CountryGroup": {
        "title": "Ország/régió",
        "placeholder": "Keresési ország vagy régió",
        "clear": "Világos",
        "history": "Keresési előzmények"
    },
    "PromotionCode": {
        "verification": {
            "title": "Utalványkód",
            "minititle": "Utalványkód",
            "input": "Kérjük, írja be a feltöltési kódot",
            "explain": "Tippek: Érintse meg a jobb felső sarokban lévő beolvasási gombot az utalványkártya QR -kódjának beolvasásához, vagy manuálisan írja be az utalványkódot (esetérzékeny), ha nem működik.",
            "submit": "Benyújt",
            "exchange": "Visszavált",
            "cancel": "Töröl",
            "Inquiry": "Biztosan cserélsz",
            "ErrorCode": "Feltöltés kódhiba"
        },
        "recharge_success": {
            "package": "Csomag",
            "content": "Sikeresen megváltották",
            "back": "Vissza a bevásárlóközpontba",
            "view_packets": "Menj a csomagomhoz"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktív",
            "isFirst": "Rangsorolt",
            "toFirst": "Állítsa be a prioritást",
            "inactive": "Inaktivált"
        },
        "periodUnits": {
            "minute": "jegyzőkönyv",
            "hour": "óra (ek)",
            "day": "nap (ek)",
            "month": "hónap (k)"
        },
        "useIntro": {
            "tip1": "A korlátlan adatcsomag magasabb prioritással rendelkezik, mint a kötet adatcsomag.",
            "tip2": "A felhasználási prioritás az azonos típusú csomagok vásárlási dátumán alapul, azaz a legkorábbi vásárlási dátummal rendelkező csomagot először használják fel, míg az egyrégiós csomagok prioritása magasabb, mint a regionális csomag.",
            "tip3": "Az azonos típusú csomagok használatának prioritását manuálisan beállíthatja."
        },
        "myFlow": "Adataim",
        "remainingFlow": "Az adatok maradtak",
        "remainingTime": "Érvényes balra",
        "remainingHighFlow": "Nagysebességű adatok maradtak",
        "validPeriod": "Érvényesség",
        "noneFlow": "Nincs adatcsomag",
        "noneFlowTip": "Kérjük, vásárolja meg az adatcsomagot, és élvezze a kiváló minőségű hálózatot",
        "buyPackFlow": "Csomagok vásárlása",
        "checkInvalidFlow": "Ellenőrizze a lejárt adatcsomagot",
        "orderList": {
            "title": "parancsaimat",
            "amount_paid": "Teljes",
            "device": "Saját tulajdonú készülék",
            "order_details": "Megrendelés részletei",
            "total_amont": "Részösszeg",
            "orderSN": "Rendelési sz.",
            "createTime": "Teremtés ideje",
            "cancelTime": "Zárva tart",
            "payTime": "Rendelési idő",
            "unsubTime": "Törölt időpont",
            "payMethod": "Fizetési mód",
            "thirdSN": "Tranzakció sz.",
            "delete": "Töröl",
            "cancel": "Megrendelés törlése",
            "unsub": "Visszatérítés",
            "goto_cancel": "Szeretné törölni a rendelést?",
            "goto_unsubscribe": "Le szeretne iratkozni a rendelésről?",
            "delete_Tips": "Törlés után a megrendelés nem folytatható, így a szervizelés utáni problémái nem kezelhetők.Biztosan törlöd?",
            "status_success": "Befejezve",
            "status_pending": "Kifizetetlen",
            "status_cancel": "Zárt",
            "status_unsub": "Törölve",
            "payMethod_stripe": "Hitelkártya"
          },
    },
    "registerlogin": {
        "create_account_tip":"Hozzon létre egy fiókot, indítsa el az exkluzív élményt",
        "select_country_tip":"Eszközhasználat ország/régió",
        "email_name": "Felad",
        "phone_name": "Telefon",
        "email_address": "E -mail cím",
        "password": "jelszó",
        "country": "ország",
        "select_country": "Válasszon egy országot",
        "cancel": "Töröl",
        "confirm": "Persze",
        "please_enter": "Kérjük, írjon be 6-20 karaktert (betűk, számok vagy szimbólumok kombinációja)",
        "select_country_tips": "Az országválasztás a helyi csomagok megtekintésére szolgál. A regisztráció után nem lehet megváltoztatni. Kérjük, erősítse meg!",
        "global_roaming": "Nemzetközi domain kód",
        "phone_number": "telefonszám",
        "agree": "egyetért",
        "user_agreement": "Felhasználói megállapodás",
        "and": "és",
        "privacy_policy": "Adatvédelmi irányelv",
        "register_login": "Iratkozzon fel vagy jelentkezzen be",
        "login_error": "A bejelentkezési szám túl gyakori, kérjük, próbálkozzon újra később!",
        "register_error": "A regisztráció száma túl gyakori, kérjük, próbálkozzon újra később!",
        "forgot_pwd": "Felejtsd el a jelszót",
        "app_tips": "Jelentkezzen be az alkalmazásba ezzel a fiókkal, miután letöltötte a további funkciók elérése érdekében.",
        "download_app": "Lépjen az alkalmazás letöltéséhez",
        "rememberPwd": "Ne feledje a jelszót",
        "third_login": "Folytat",
        "agreement_tips": "Kérjük, jelölje be a felhasználói megállapodást és az adatvédelmi irányelv mezőt",
        "selectCountry_tips": "Kérjük, kérjük, vegye figyelembe, hogy a regisztrált ország közvetlenül befolyásolja a következő fizetési módszereket és valutákat, kérjük, válassza az Ön igényeit.",
        "login_error_cancel": "A felhasználó megszakította a bejelentkezést",
        "login_error_auth": "Engedélyezze a felugró ablakokat a böngésző beállításaiban",
        "device_tips": "Eszköz aktiválásra vár. Feldolgozás 24 órán belül."
    },
    "forgotPwd": {
        "forgot_pwd": "Felejtsd el a jelszót",
        "email_address": "E -mail cím",
        "next": "Következő",
        "email_has_been_sent": "Elküldtük az ellenőrző kódot a következő címre: %@email. Kérjük, kattintson a linkre, és kövesse a jelszavának letöltéséhez a lépéseket.",
        "have_retrieved_it": "Megtaláltam",
        "unable_to_receive_email": "Nem tudja megkapni az e -mailt? Kérjük, ellenőrizze, hogy vannak -e e -mailek a %@email a spam és a törölt levelek könyvtára alatt",
        "or": "vagy",
        "resend": "Újraindít",
        "global_roaming": "Nemzetközi domain kód",
        "phone_number": "telefonszám",
        "verification_code_has_been_sent": "Elküldtük az ellenőrző kódot a következő címre:",
        "verification_code": "Ellenőrzési kód",
        "no_verification_code_received": "Nem kapta meg az ellenőrző kódot?",
        "please_enter": "Kérjük, írjon be 6-20 karaktert (betűk, számok vagy szimbólumok kombinációja)",
        "reset_password": "A jelszó visszaállítása",
        "reset_successful": "A sikeresen állítsa vissza"
    },
    "coupons": {
        "coupons_name": "Kuponok",
        "no_coupons": "Még nincs kupon",
        "no_data": "Még nincs adat",
        "applicable_to_the_following": "A kuponok a következő adatcsomaghoz alkalmasak"
    },
    "digital":{
        "title":"Eszköz SN",
        "purchased":"A vásárlásaim",
        "viewAll":"Több",
        "skinStore":"Termékbolt",
        "completed":"Megvásárolt",
        "goBuy":"Vétel",
        "order": {
          "title":"Megvásárolt megrendelések"
        },
        "detail": {
          "describe":"Leírás"
        }
    },
    "viewPL": {
        "other": 'más'
    },
    "invalidFlow": {
        "stateName": "Állapot",
        "state": {
            "NOT_ACTIVATED": "Inaktivált",
            "IN_USING": "Elérhető",
            "USE_END": "Kimerült",
            "EXPIRE": "Lejárt",
            "TRANSFER": "Átruházás",
            "UNSUBSCRIBE": "Töröl",
            "VALID": "Érvényes",
            "INVALID": "Érvénytelen",
            "EXCHANGE_POINTS": "A pontok beváltása"
        },
        "noneFlow": "Nincs lejárt adatcsomag",
        "pageName": "Lejárt adatcsomag"
    },
    "flowDetail": {
        "title": "Adat részletei",
        "flow": "Adat",
        "validTime": "Érvényes indítás",
        "invalidTime": "Addig érvényes",
        "coverage": "Lefedettség",
        "useIntro": "Feltételek",
        "purchaseTime": "Vásárolt",
        "subtotal": "Altotikus",
        "status": "Állapot",
        "cancel": "Töröl",
        "buyAgain": "Vedd újra",
        "validity": "Érvényesség",
        "tip": "Értesítés",
        "cancelTip": "Leiratkozni a csomagot?",
        "dataLeft": "Az adatok maradtak"
    },
    "netError": {
        "try_again": "Próbálkozzon újra",
        "net_error": "Nincs hálózat",
        "try_again_desc": "Kérjük, ellenőrizze a hálózati beállítást, és próbálja újra"
    },
    "loadFail": {
        "try_again": "Próbálkozzon újra",
        "load_fail": "A betöltés sikertelen",
        "load_fail_desc": "Az adatok betöltése sikertelen, próbálkozzon újra",
        "IMEI_Not_Exist": "Imei nem létezik, kérjük, próbáljon belépni a jobb bejáratból",
        "Project_Not_Exist": "Hiba fordul elő. Kérjük, vegye fel a kapcsolatot az ügyfélszolgálatra. (01)",
        "commonError": "Hiba fordul elő. Kérjük, vegye fel a kapcsolatot az ügyfélszolgálatra."
    },
    "settlement_Easy_and_convenient": "Könnyű és kényelmes",
    "settlement_Great_deal": "Nagy üzlet",
    "settlement_Safe_and_secure": "Biztonságos és biztonságos",
    "settlement_Autopay_service_regulation": "Autopay szolgáltatási szabályozás",
    "settlement_Read": "Olvas",
    "settlement_No_coupon": "Nincs elérhető kupon",
    "settlement_Subtotal": "Altotikus",
    "settlement_Coupon": "Kuponok",
    "settlement_TOTAL": "Teljes",
    "settlement_promotion_tip": "A promóciós ajánlat nem használható a kuponokkal együtt",
    "settlement_coupon_tip": "A kupon nem használható más promóciós ajánlatokkal összefüggésben",
    "member_myFlow_noList": "Nincs adat",
    "detail_se_content": "Biztonságos, könnyű és kényelmes módon. Bármikor leiratkozhat",
    "Enter_Promo_code": "Promóciós kód",
    "Enter_Promo_Coupon": "Kuponok",
    "settlement_Not_used_coupon": "A kupon nem használt",
    "settlement_Available_coupon": "Elérhető",
    "settlement_Unavailable_coupon": "Nem érhető el",
    "please_Enter_Promo_code": "Kérjük, írja be a promóciós kódot",
    "please_Select_Coupon_use": "Kérjük, válassza ki a használni kívánt kuponot",
    "Buy_Now": "Vásároljon most",
    "Dont_Use_Any": "Ne használjon semmit",
    "settlement_confirm": "Megerősít",
    "settlement_tips": "Megerősít",
    "flowDetail_unsubscribe": "Leiratkozás",
    "flowDetail_unsubscribed": "Leiratkozott",
    "flowDetail_isCancelPackage": "Leiratkozni a csomagot?",
    "flowDetail_confirmAgreementUnsubscribe": "A leiratkozás után nem lehet sokat. Biztos benne, hogy leiratkozni szeretne?",
    "flowDetail_cancel": "Töröl",
    "flowDetail_cancelSuccess": "Leiratkozni sikeresen",
    "packages_detail_promotion": "Előléptetés",
    "orderTips":{
        "iDay" : "nap",
        "iDays" : "napok",
        "iMonth" : "hónap",
        "iMonths" : "hónapok",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Az első vételeden, Fizessen a %@money/%@periodSymbol később, Bármikor leiratkozhat",
        'Monthly_discount':"Mentse el a %@saveMoney minden %@period! Bármikor leiratkozhat",
        'Ordinary_monthly_package':"Biztonságos, könnyű és kényelmes módon. Bármikor leiratkozhat",
        "AlreadyPurchased":'Sajnálom, hogy jelenleg csak egy adatcsomagra iratkozhat fel. Kérjük, írja le a “%@” eliratkozását, és iratkozzon fel később minden kívánt csomagra, miután lejárta.',
        "Contract_recommendation_First":'<label>Az AutoPay Service -vel, az első vételnél, csak fizessen</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Bármikor leiratkozhat'
        +'<a class="btn">Feliratkozás ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Autófizetés szolgáltatásával csak fizetned kell</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Bármikor leiratkozhat'
        +'<a class="btn">Feliratkozás ></a></p>',
        "Contract_recommendation_General":"<label>Autopay Service -vel</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Biztonságos, könnyű és kényelmes módon. Bármikor leiratkozhat'
        +'<a href="javascript:;" class="btn">Feliratkozás ></a></p>',
        'BanlanceDoubleCheck':'Biztos benne, hogy egyenleggel szeretne fizetni?',
    },
    feedback: {
        title: "visszacsatolás",
        placeholder: "Kérjük, írja be a meglátogatni kívánt országot vagy bármilyen más kérdést, és a lehető leghamarabb kielégítjük az Ön igényeit!",
        submit: "Beküldés",
        submit_success: "Sikeres benyújtás",
        other_opinions: "Egyéb vélemények",
    },
    view_country_input: 'Kérjük, adja meg fiókját',
    "select_package": {
        "title": "Válasszon Adatot",
        "allPackage": "Minden Adat",
        "type": "Típus",
        "flow": "Adatok",
        "month_package": "Havi Terv",
        "flow_package": "Adatcsomag",
        "time": "Időtartam",
        "period": "Ciklus",
        "auto_debit": "Auto-Debit Információ",
        "auto_subscribe": "Auto-Frissítés",
        "detail": "Adat Részletek",
        "carrier": "Támogatott Operátorok",
        "country": "Fedezett Országok",
        "notice": "Vásárlási Útmutató"
    }
}